import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import Select from "react-select";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@radix-ui/react-popover";
import CalenderNew from "../../assets/svg/calendarWhite.svg";
import CalenderBlackSvg from "../../assets/svg/calendarBlack.svg";
import CrossSvg from "../../assets/svg/crossNew.svg";
import DownArrow from "../../assets/svg/DownArrow.svg";
import DownArrowWhite from "../../assets/svg/downArrowWhite.svg";
import SearchSvg from "../../assets/svg/search.svg";
import InputText from "@/components/common/InputText";
import { RISKFIELDS } from "@/api/types/enums";
import { useSearchParams } from "react-router-dom";
import useDebounce from "@/hooks/useDebounce";
import { useTranslation } from "react-i18next";
import {
  ImpactEnumSchema,
  ProbabilityEnumSchema,
  SeverityEnumSchema,
  StatusEnumSchema,
  TrendEnumSchema,
} from "@backend/src/schemas/enums";
import { RiskType } from "@/api/mutation/useAddRIskMutation";
import { useUser } from "@/hooks/useUser";
import { getSeverityAndColor } from "@/helperFuntions/riskSeverity";
type Options = { label: string; value: string };

type Filter = {
  data: RiskType[] | undefined;
  fieldToShow: RISKFIELDS[];
  filteredData: (data: RiskType[] | undefined) => void;
  applied?: (data: boolean) => void;
  small?:boolean
};
export type TaskFilterRef = {
  callFilter: () => void;
};
const RiskFilter = (props: Filter) => {
  const { data, fieldToShow } = props;
  const [popOverCLose, setPopOverCLose] = useState(false);
  const [filter, setFilter] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    ApplyFilter();
    if (data?.length == 0) {
      props.filteredData([]);
    }
  }, [data]);

  const [searchString, setSearchString] = useDebounce<string | undefined>(
    undefined,
    400
  );

  useEffect(() => {
    const tempData: RiskType[] = [];
    if (searchString !== undefined) {
      data?.forEach((element) => {
        const searchStringLower = searchString?.toLowerCase();
        const taskRiskNameIdLower = element.riskNameId?.toLowerCase();
        const taskDescriptionLower = element.description?.toLowerCase();
        if (
          taskDescriptionLower?.includes(searchStringLower) ||
          taskRiskNameIdLower?.includes(searchStringLower)
        ) {
          tempData.push(element);
        }
      });
      props.filteredData(tempData);
    }
  }, [searchString,data]);

  const reactSelectStyle = {
    control: (
      provided: Record<string, unknown>,
      state: { isFocused: boolean }
    ) => ({
      ...provided,
      border: "1px solid #E7E7E7",
      paddingTop: "0rem",
      paddingBottom: "0rem",
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
      "&:hover": {
        outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
        boxShadow: "0px 0px 0px #299d91",
      },
    }),
    option: (
      provided: Record<string, unknown>,
      state: { isSelected: boolean }
    ) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      background: state.isSelected ? "#299d91" : "white",
      "&:hover": {
        color: "white",
        background: "#299d9199",
      },
    }),
  };

  const removeDuplicatesById = (arr: RiskType[]) => {
    const uniqueIds = new Set();
    return arr.filter(
      ({ riskId }) => !uniqueIds.has(riskId) && uniqueIds.add(riskId)
    );
  };
  const [filterApplyed, setFilterApplied] = useState(false);
  const findSeverity =(data:RiskType ) =>{
    const impactLevels = Object.keys(ImpactEnumSchema);
    const probabilityLevels = Object.keys(ProbabilityEnumSchema);
    const severity = getSeverityAndColor(
      impactLevels.findIndex((t) => t == data.impact),
      probabilityLevels.findIndex((t) => t == data.probability),
      user?.userOrganisation[0].organisation?.severityTypes ?? []
    ).severity;
    return severity;

  };
  const ApplyFilter = () => {
    let filteredData = data;
    if (filter && Boolean(filter.get("type"))) {
      filteredData = filteredData?.filter(
        (data) => data.type == filter.get("type")
      );
    }
    if (filter && Boolean(filter.get("impact"))) {
      filteredData = filteredData?.filter(
        (data) => data.impact == filter.get("impact")
      );
    }
    if (filter && Boolean(filter.get("severity"))) {
      filteredData = filteredData?.filter(
        (data) => findSeverity(data) == filter.get("severity")
      );
    }
    if (filter && Boolean(filter.get("status"))) {
      filteredData = filteredData?.filter(
        (data) => data.status == filter.get("status")
      );
    }
    if (filter && Boolean(filter.get("trend"))) {
      filteredData = filteredData?.filter(
        (data) => data.trend == filter.get("trend")
      );
    }
    if (filter && Boolean(filter.get("probability"))) {
      filteredData = filteredData?.filter(
        (data) => data.probability == filter.get("probability")
      );
    }
    let applyFilter = 0;
    filter.forEach((e) => {
      if (Boolean(e) || e !== "false") {
        applyFilter++;
      }
    });

    if (applyFilter !== 0 && filteredData) {
      setFilterApplied(true);
      filteredData = removeDuplicatesById(filteredData);
      props.filteredData(filteredData);
    } else {
      props.filteredData(data);
      setFilterApplied(false);
    }

    setPopOverCLose(false);
  };
  const resetFilter = () => {
    setFilterApplied(false);
    setFilter({});
    props.filteredData(data);
  };
  const setParamFilter = (key: string, value: string) => {
    filter.set(key, value);
    setFilter(filter);
    if ((value == "undefined" && !value) || value == "false") {
      filter.delete(key);
      setFilter(filter);
    }
  };
  function enumToOptions(enumObj: any): Options[] {
    return Object.keys(enumObj)?.map((key) => ({
      label: t(enumObj[key as keyof typeof enumObj]),
      value: enumObj[key as keyof typeof enumObj],
    }));
  }
  const { user } = useUser();
  const [riskType, setRiskType] = useState<Options[]>();
  useEffect(() => {
    if (user && user.userOrganisation[0].organisation.riskType) {
      if (user?.userOrganisation?.[0]?.organisation?.riskType) {
        setRiskType([
          { label: t('select type'), value: '' },
          ...user.userOrganisation[0].organisation.riskType.map((riskType) => ({
            label: riskType,
            value: riskType,
          })),
        ]);
      } else {
        setRiskType([{ label: '', value: '' }]); // Default or fallback value
      }

    }
  }, [user]);
  return (
    <div>
      <div className="flex w-full justify-between items-center gap-2">
        <div className="flex justify-between w-full gap-2 text-gray-500">
          <div className="flex justify-between items-center gap-6 px-3 w-full relative">
            <div>
              <Popover open={popOverCLose}>
                <PopoverTrigger className="w-full ">
                  <Button
                    variant={"outline"}
                    className="w-fit h-10 rounded-xl px-2"
                    style={{
                      backgroundColor: filterApplyed ? "#299d91" : "",
                      color: filterApplyed ? "#ffffff" : "",
                    }}
                    onClick={() => setPopOverCLose(!popOverCLose)}
                  >
                    <div className="flex justify-between gap-5 items-center">
                      <div className="flex items-center justify-between gap-1">
                        <div className="w-5">
                          <img
                            src={filterApplyed ? CalenderNew : CalenderBlackSvg}
                          />
                        </div>
                        {!props.small && t("Filters")}{" "}
                      </div>
                      <div className="w-5 ">
                        <img src={filterApplyed ? DownArrowWhite : DownArrow} />
                      </div>
                    </div>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="z-20 absolute bg-white shadow-lg mr-5 max-h-screen overflow-y-auto -translate-x-[20%]">
                  <div className="p-3 w-80 flex flex-col gap-3 !z-20">
                    <div>
                      <div className="text-lg font-semibold">
                        {t("Filters")}
                      </div>
                      <hr />
                    </div>
                    {fieldToShow.includes(RISKFIELDS.TYPE) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          options={riskType}
                          defaultValue={
                            filter.get("type")
                              ? {
                                label: t(filter.get("type")??""),
                                value: filter.get("type"),
                              }
                              : {
                                label: t("select type"),
                                value: "",
                              }
                          }
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("type", "");
                            } else {
                              setParamFilter("type", String(e?.value));
                            }
                          }}
                          placeholder={t("select type")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(RISKFIELDS.IMPACT) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("impact")
                              ? {
                                label: t(filter.get("impact")??''),
                                value: filter.get("impact"),
                              }
                              : {
                                label: t("select impact"),
                                value: "",
                              }
                          }
                          options={[{ label: t("select impact"), value: '' },...enumToOptions(ImpactEnumSchema)]}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("impact", "");
                            } else {
                              setParamFilter("impact", String(e?.value));
                            }
                          }}
                          placeholder={t("select impact")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(RISKFIELDS.SEVERITY) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("severity")
                              ? {
                                label: t(filter.get("severity")??''),
                                value: filter.get("severity"),
                              }
                              : {
                                label: t("select severity"),
                                value: "",
                              }
                          }
                          options={[{ label: t("select severity"), value: '' },...enumToOptions(SeverityEnumSchema)]}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("severity", "");
                            } else {
                              setParamFilter("severity", String(e?.value));
                            }
                          }}
                          placeholder={t("select severity")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(RISKFIELDS.STATUS) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("status")
                              ? {
                                label: t(filter.get("status")??""),
                                value: filter.get("status"),
                              }
                              : {
                                label: t("select status"),
                                value: "",
                              }
                          }
                          options={[{ label: t("select status"), value: '' },...enumToOptions(StatusEnumSchema)]}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("status", "");
                            } else {
                              setParamFilter("status", String(e?.value));
                            }
                          }}
                          placeholder={t("select status")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {/* {fieldToShow.includes(RISKFIELDS.RESPONSIBLE) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("Responsible")
                              ? {
                                  label: filter.get("Responsible"),
                                  value: filter.get("Responsible"),
                                }
                              : {
                                  label: t("select Responsible"),
                                  value: "",
                                }
                          }
                          options={enumToOptions(ResponsibleEnum)}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("Responsible", "");
                            } else {
                              setParamFilter("Responsible", String(e?.value));
                            }
                          }}
                          placeholder={t("select Responsible")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )} */}
                    {fieldToShow.includes(RISKFIELDS.TREND) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("trend")
                              ? {
                                label: t(filter.get("trend")??""),
                                value: filter.get("trend"),
                              }
                              : {
                                label: t("select trend"),
                                value: "",
                              }
                          }
                          options={[{ label: t("select trend"), value: '' },...enumToOptions(TrendEnumSchema)]}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("trend", "");
                            } else {
                              setParamFilter("trend", String(e?.value));
                            }
                          }}
                          placeholder={t("select trend")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(RISKFIELDS.PROBABILITY) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("probability")
                              ? {
                                label: t(filter.get("probability")??""),
                                value: filter.get("probability"),
                              }
                              : {
                                label: t("select probability"),
                                value: "",
                              }
                          }
                          options={[{ label: t("select probability"), value: '' },...enumToOptions(ProbabilityEnumSchema)]}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("probability", "");
                            } else {
                              setParamFilter("probability", String(e?.value));
                            }
                          }}
                          placeholder={t("select probability")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.length != 0 && (
                      <div className="w-full flex gap-2">
                        <Button
                          className="w-full mt-4"
                          variant={"destructive"}
                          onClick={() => setPopOverCLose(false)}
                        >
                          {t("close")}
                        </Button>
                        <Button
                          className="w-full mt-4"
                          variant={"primary_outline"}
                          onClick={ApplyFilter}
                        >
                          {t("apply")}
                        </Button>
                      </div>
                    )}
                  </div>
                </PopoverContent>
              </Popover>
            </div>
            {filterApplyed && (
              <div>
                <Button
                  size={"sm"}
                  className="w-5 h-5 rounded-[50%] px-2 bg-[#EA4335] hover:bg-[#EA4335] absolute left-28  bottom-7"
                  variant={"outline"}
                  onClick={resetFilter}
                >
                  <div className="flex items-center justify-between gap-2 ">
                    <div className="w-2">
                      <img src={CrossSvg} className="m-auto" />
                    </div>
                  </div>
                </Button>
              </div>
            )}
            <div className="w-full flex gap-2 relative items-center">
              <InputText
                className={`pl-11 pr-3 truncate mt-0 h-10 ${props.small ? "w-40": "w-80"} border-primary-500/5 bg-primary-500/5 rounded-md focus:outline-primary-700`}
                onChange={(e) => setSearchString(e.target.value)}
                placeholder={t("search_risk_by_name")}
              />
              <img
                src={SearchSvg}
                className="absolute h-5 left-3 top-3"
                width={"20px"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskFilter;
